module.exports = __webpack_public_path__ + "img/Lenna Wolffe.a08dbe71.jpg";